export default __webpack_public_path__ + "static/Lebanon-Header-copy-3da209c1071ba89684c49b5fed1cf48c.jpg";